(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wibc-cnc-quote-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-wibc-digits-only]')) return;
    event.target.value = event.target.value.replace(/[^0-9]/g, '');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wibc-trade-enquiry-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class WibcTokenField {
      constructor(field) {
        this.field = field;
        this.input = field.querySelector('[data-token-input]');
        this.list = field.querySelector('[data-token-list]');
        this.addButton = field.querySelector('[data-token-add]');
        this.tokens = [];
        this.addButton.addEventListener('click', () => this.addCurrent());
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ',') {
            event.preventDefault();
            this.addCurrent();
          }
        });
        this.input.form?.addEventListener('submit', () => this.prepareSubmit());
      }

      normalise(value) {
        return value.trim().replace(/\\s+/g, ' ');
      }

      addCurrent() {
        const value = this.normalise(this.input.value);
        if (!value) return;
        if (!this.tokens.some((token) => token.toLowerCase() === value.toLowerCase())) {
          this.tokens.push(value);
        }
        this.input.value = '';
        this.render();
      }

      remove(value) {
        this.tokens = this.tokens.filter((token) => token !== value);
        this.render();
      }

      prepareSubmit() {
        const typedValue = this.normalise(this.input.value);
        if (typedValue && !this.tokens.some((token) => token.toLowerCase() === typedValue.toLowerCase())) {
          this.tokens.push(typedValue);
        }
        this.input.value = this.tokens.join(', ');
      }

      render() {
        this.list.innerHTML = '';
        this.tokens.forEach((token) => {
          const chip = document.createElement('span');
          chip.className = 'wibc-token-field__token';
          const label = document.createElement('span');
          label.textContent = token;
          const remove = document.createElement('button');
          remove.className = 'wibc-token-field__remove';
          remove.type = 'button';
          remove.innerHTML = '&times;';
          remove.setAttribute('aria-label', `Remove ${token}`);
          remove.addEventListener('click', () => this.remove(token));
          chip.append(label, remove);
          this.list.append(chip);
        });
      }
    }

    const initTokenFields = () => {
      document.querySelectorAll('[data-wibc-token-field]').forEach((field) => new WibcTokenField(field));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initTokenFields, { once: true });
    } else {
      initTokenFields();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
